<template>
  <div>Загрузка...</div>
</template>

<script>
  export default {
    mounted() {
      this.$store.dispatch('Account/esiAuth', this.$route.query.code).then((account) => {
        this.$auth.bind(account.token)
        this.$locale.change(account.locale)
        this.$router.push({name: 'dashboard'})
      }).catch((error) => {
        this.$toast.open({
          message: error.data[Object.keys(error.data)[0]][0],
          type: 'is-danger'
        })
        setTimeout(() => this.$router.push('/'), 2000)
      })
    }
  }
</script>

<style scoped>

</style>
